import { render, staticRenderFns } from "./CoozzyColumnIcon.vue?vue&type=template&id=1f93d4ec&scoped=true"
import script from "./CoozzyColumnIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyColumnIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyColumnIcon.vue?vue&type=style&index=0&id=1f93d4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93d4ec",
  null
  
)

export default component.exports